// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__SWLwl"};